import ActivityCard, { DefaultActivityContent } from "components/ActivityPanel/ActivityCard";
import React from "react";

interface Props {
  activity: server.dto.WebformActivity
}

export const WebformActivityCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
    <DefaultActivityContent activity={activity} />
  </ActivityCard>
}